import type { RunStatsSnapshot } from './RunStats';

export class PostGameRecap {
  private root?: HTMLDivElement;

  show(snapshot: RunStatsSnapshot, isVictory: boolean, onRestart: () => void) {
    if (this.root) {
      this.root.remove();
    }

    this.root = document.createElement('div');
    this.root.style.position = 'fixed';
    this.root.style.inset = '0';
    this.root.style.backgroundColor = 'rgba(0, 0, 0, 0.85)';
    this.root.style.zIndex = '9999';
    this.root.style.display = 'flex';
    this.root.style.flexDirection = 'column';
    this.root.style.alignItems = 'center';
    this.root.style.padding = '5vh 20px';
    this.root.style.overflowY = 'auto';
    this.root.style.fontFamily = 'Arial, sans-serif';
    this.root.style.color = '#fff';
    this.root.style.backdropFilter = 'blur(8px)';

    const container = document.createElement('div');
    container.style.width = '100%';
    container.style.maxWidth = '400px';
    container.style.display = 'flex';
    container.style.flexDirection = 'column';
    container.style.gap = '20px';

    // Title
    const title = document.createElement('h1');
    title.textContent = isVictory ? '通关成功' : '执行失败';
    title.style.color = isVictory ? '#fbbf24' : '#ef4444'; // amber-400 : red-500
    title.style.textAlign = 'center';
    title.style.margin = '0';
    title.style.fontSize = '32px';
    title.style.textShadow = `0 0 10px ${isVictory ? 'rgba(251,191,36,0.5)' : 'rgba(239,68,68,0.5)'}`;
    container.appendChild(title);

    // Basic Stats
    const basicStats = document.createElement('div');
    basicStats.style.display = 'flex';
    basicStats.style.justifyContent = 'space-around';
    basicStats.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
    basicStats.style.padding = '12px';
    basicStats.style.borderRadius = '12px';
    basicStats.innerHTML = `
      <div style="text-align: center">
        <div style="font-size: 12px; color: #aaa">总伤害</div>
        <div style="font-weight: bold; color: #4ade80">${snapshot.damageDealtBySource.reduce((acc, curr) => acc + curr.damage, 0).toFixed(0)}</div>
      </div>
      <div style="text-align: center">
        <div style="font-size: 12px; color: #aaa">承伤</div>
        <div style="font-weight: bold; color: #f87171">${snapshot.damageTakenBySource.reduce((acc, curr) => acc + curr.damage, 0).toFixed(0)}</div>
      </div>
      <div style="text-align: center">
        <div style="font-size: 12px; color: #aaa">击杀</div>
        <div style="font-weight: bold; color: #60a5fa">${snapshot.damageDealtBySource.reduce((acc, curr) => acc + curr.kills, 0)}</div>
      </div>
    `;
    container.appendChild(basicStats);

    // Damage Dealt Chart
    const dealtSection = this.createChartSection('输出构成 (伤害来源)', snapshot.damageDealtBySource, '#4ade80');
    if (dealtSection) container.appendChild(dealtSection);

    // Damage Taken Chart
    const takenSection = this.createChartSection('承伤来源 (危险因素)', snapshot.damageTakenBySource, '#f87171');
    if (takenSection) container.appendChild(takenSection);

    // Restart Button
    const btn = document.createElement('button');
    btn.textContent = '返回 / 重新开始';
    btn.style.marginTop = '10px';
    btn.style.padding = '16px';
    btn.style.borderRadius = '12px';
    btn.style.border = 'none';
    btn.style.backgroundColor = '#fbbf24';
    btn.style.color = '#000';
    btn.style.fontWeight = 'bold';
    btn.style.fontSize = '18px';
    btn.style.cursor = 'pointer';
    btn.style.boxShadow = '0 4px 15px rgba(251,191,36,0.3)';
    btn.onclick = () => {
      this.hide();
      onRestart();
    };
    container.appendChild(btn);

    this.root.appendChild(container);
    document.body.appendChild(this.root);
  }

  hide() {
    if (this.root) {
      this.root.remove();
      this.root = undefined;
    }
  }

  private createChartSection(titleText: string, data: { label: string; damage: number }[], color: string) {
    if (data.length === 0) return null;

    const section = document.createElement('div');
    section.style.backgroundColor = 'rgba(255, 255, 255, 0.05)';
    section.style.padding = '16px';
    section.style.borderRadius = '12px';

    const title = document.createElement('h3');
    title.textContent = titleText;
    title.style.margin = '0 0 12px 0';
    title.style.fontSize = '14px';
    title.style.color = '#ccc';
    section.appendChild(title);

    const maxDamage = Math.max(...data.map(d => d.damage));

    data.slice(0, 6).forEach(item => {
      if (item.damage <= 0) return;
      const row = document.createElement('div');
      row.style.marginBottom = '8px';

      const labelRow = document.createElement('div');
      labelRow.style.display = 'flex';
      labelRow.style.justifyContent = 'space-between';
      labelRow.style.fontSize = '12px';
      labelRow.style.marginBottom = '4px';

      const name = document.createElement('span');
      name.textContent = item.label;
      const val = document.createElement('span');
      val.textContent = item.damage.toFixed(0);
      val.style.fontWeight = 'bold';

      labelRow.appendChild(name);
      labelRow.appendChild(val);

      const barContainer = document.createElement('div');
      barContainer.style.height = '6px';
      barContainer.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
      barContainer.style.borderRadius = '3px';
      barContainer.style.overflow = 'hidden';

      const bar = document.createElement('div');
      bar.style.height = '100%';
      bar.style.backgroundColor = color;
      bar.style.width = `${(item.damage / maxDamage) * 100}%`;
      bar.style.borderRadius = '3px';

      barContainer.appendChild(bar);
      row.appendChild(labelRow);
      row.appendChild(barContainer);
      section.appendChild(row);
    });

    return section;
  }
}
